module.exports = __webpack_public_path__ + "static/media/BDS-1000-X-350.2dc05053.png";